import { Icon, IconButton } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import DateFilter from "../../components/dateFilter";
import Filters from "../../components/Filters";
import Input from "../../components/Input";
import MetricsCard from "../../components/MetricsCard";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import StatusAlert from "../../components/StatusAlert";
import UtilityFilters from "../../components/utilityFilter";
import Functions from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import {
  assignTerminal,
  getCoordinatorPosDashboard,
  getPOSDashboard,
  getPOSTransactions,
  getTerminalDetails,
  retrieveTerminal,
} from "../../redux/actions/POSAction";
import { transactionTypes } from "../../redux/actions/TransactionActions";
import PrimaryTheme from "../../Themes/Primary";
import "./pos.scss";
export default function POSDetails() {
  const [searchState, setSearchState] = React.useState("");
  const transactions = useSelector((state: Reducers) => state.transactions);
  const alert = useSelector((state: Reducers) => state.alert);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const terminals = useSelector((state: Reducers) => state.terminals);
  const agents = useSelector((state: Reducers) => state.agents);
  const userType = useSelector((state: Reducers) => state.userType);
  const user = useSelector((state: any) => state.user);
  const coordinatorType = useSelector(
    (state: Reducers) => state.coordinatorType
  );
  const types = useSelector((state: Reducers) => state.transactionTypes);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const params: any = useParams();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [type, setType] = React.useState(0); // retrieve = 1, assign = 2
  const [pin, setPin] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [terminal, setTerminal]: any = React.useState("");
  const [comment, setComment]: any = React.useState("");
  const [title, setTitle]: any = React.useState("");
  const [subtitle, setSubtitle]: any = React.useState("");
  const [agent, setAgent]: any = React.useState("");
  const [agentId, setAgentId]: any = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [rangeState, setrangeState] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  let list = transactions && transactions.items;

  let agentList = agents && agents.items;

  const filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: params.id,
    whereCondition: JSON.stringify(filter),
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getPOSTransactions(paginationConfig));
  };

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  const goto = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getPOSTransactions(paginationConfig));
    dispatch(getTerminalDetails(params.id));
  };

  const handleRetrieval = (e: any) => {
    e.preventDefault();

    const data = {
      posTerminalId: terminals.id,
      comment,
      transactionPin: pin,
    };

    setLoading(true);
    setSubmitted(true);
    dispatch(retrieveTerminal(data));
  };
  const handleClear = () => {
    paginationConfig.whereCondition = JSON.stringify(filter);

    dispatch(getPOSTransactions(paginationConfig));
    setSearchState("");
    dispatch({
      type: "LOADING",
      payload: true,
    });
  };
  const handleMapping = (e: any) => {
    e.preventDefault();

    const data = {
      agentId,
      posTerminalId: terminals.id,
      transactionPin: pin,
    };

    setLoading(true);
    setSubmitted(true);
    dispatch(assignTerminal(data));
  };

  const openModal = (type: number) => {
    setType(type);
    setAgent(terminals.agentName);
    setTerminal(terminals.terminalId);

    switch (type) {
      case 1:
        setTitle("RETRIEVE POS TERMINAL");
        setSubtitle("Retrieve a POS Terminal from an Agent account");
        break;
      case 2:
        setTitle("ASSIGN POS TERMINAL");
        setSubtitle("Map a POS Terminal to an Agent account");
        break;
      default:
        setTitle("RETRIEVE POS TERMINAL");
        setSubtitle("Retrieve a POS Terminal from an Agent account");
    }

    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  const closeModal = () => {
    setType(0);
    setLoading(false);
    setType(0);
    setAgent("");
    setTerminal("");
    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  React.useEffect(() => {
    if (Object.entries(terminals).length !== 0) {
      setAgentId(terminals.agentId);
      setAgent(terminals.agentName);
      setTerminal(terminals.terminalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [terminals]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getPOSTransactions(paginationConfig));
    dispatch(transactionTypes());
    return () => {
      dispatch({
        type: "TERMINALS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (userType === "5") {
      dispatch(getPOSDashboard(params.id));
    } else {
      dispatch(getCoordinatorPosDashboard());
    }

    dispatch(getTerminalDetails(params.id));

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {},
      });
      dispatch({
        type: "TERMINALS",
        payload: {},
      });
      dispatch({
        type: "DASHBOARD",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  React.useEffect(() => {
    if (searchState !== "") {
      dispatch({
        type: "LOADING",
        payload: true,
      });
      filter.searchText = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);
      dispatch(getPOSTransactions(paginationConfig));
    } else {
      dispatch(getPOSTransactions(paginationConfig));
    }
  }, [searchState]);

  // console.log({ filter })
  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        setSubmitted(false);
        setLoading(false);

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        setPin("");
        setSubmitted(false);
        setLoading(false);
        setComment("");

        if (alert.message === "Successful") {
          closeModal();

          switch (type) {
            case 1:
              setTitle("Terminal Retrieved Successfully");
              setSubtitle(
                "The POS Terminal has been retrieved from your agent. Proceed to Map the Terminal to another agent instantly. If the Terminal needs repairs, kindly contact your sales rep Or send the terminal across to our main office"
              );
              break;

            case 2:
              setTitle("Terminal Mapped Successfully");
              setSubtitle(
                "The POS Terminal has been retrieved from your agent. Proceed to Map the Terminal to another agent instantly. If the Terminal needs repairs, kindly contact your sales rep Or send the terminal across to our main office"
              );
              break;
            default:
              setTitle("RETRIEVE POS TERMINAL");
              setSubtitle("Retrieve a POS Terminal from an Agent account");
          }

          dispatch({
            type: "STATUS_ALERT",
            payload: true,
          });
        }

        handleRefresh();

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const handleSelect = (date: any) => {
    setrangeState([date.selection]);

    filter.dateCreatedFrom = date.selection.startDate;
    filter.dateCreatedTo = date.selection.endDate;
    paginationConfig.whereCondition = JSON.stringify(filter);
  };
  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar onClick={() => history.goBack()} canGoBack />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <div className="row pos-service-overlay">
            <div className="col">
              <h1
                className="mb-5 pos-details-title"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  textTransform: "uppercase",
                  fontSize: PrimaryTheme.fontSizes?.subtitle,
                }}
              >
                Pos Transactions
              </h1>
            </div>
            {/* {userType === "5" && (
              <div className="col-4 text-right">
                {Object.entries(dashboard).length !== 0 && (
                  <React.Fragment>
                    {dashboard.assignedToAgent && (
                      <button
                        onClick={() => openModal(1)}
                        className="badge-pill btn btn-warning pl-3 pr-3 small"
                        style={{}}
                      >
                        Retrieve
                      </button>
                    )}

                    {!dashboard.assignedToAgent && (
                      <button
                        onClick={() => openModal(2)}
                        className="badge-pill btn btn-success pl-3 pr-3 small"
                        style={{}}
                      >
                        Assign
                      </button>
                    )}
                  </React.Fragment>
                )}
              </div>
            )} */}
          </div>

          {/* cards  */}
          <div className="row mb-5 pos-service-overlay">
            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase titele-name"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Terminal ID
              </h5>
              <h4
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  wordWrap: "break-word",
                }}
              >
                {dashboard.terminalId ? dashboard.terminalId : "-"}
              </h4>
              <h6 className="text-uppercase " style={{}}>
                {dashboard.serialNumber ? (
                  <span className="titele-name">
                    {" "}
                    SN:{" "}
                    <span style={{ color: "#4D4F5C" }}>
                      {dashboard.serialNumber}
                    </span>
                  </span>
                ) : (
                  "-"
                )}
              </h6>
            </div>

            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase titele-name"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Terminal Status
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.weeklyTargetStatusName
                  ? dashboard.weeklyTargetStatusName
                  : "-"}
              </h3>
            </div>
            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase titele-name"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Total Performance
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.percentagePerformance
                  ? dashboard.percentagePerformance
                  : "-"}
              </h3>
            </div>
            {user.isSuperAggregator ? (
              <div
                className="col-md col-12"
                style={{
                  height: "auto",
                  position: "relative",
                }}
              >
                <h5
                  className="text-uppercase titele-name"
                  style={{
                    color: PrimaryTheme.primary,
                  }}
                >
                  Aggregator Details
                </h5>

                <h6 className="text-uppercase " style={{}}>
                  {dashboard.aggregatorName ? dashboard.aggregatorName : "-"}
                </h6>
                <h3
                  className="text-uppercase  text-bold mb-0"
                  style={{
                    color: PrimaryTheme.dark,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                  }}
                >
                  {dashboard.aggregatorPhoneNumber
                    ? dashboard.aggregatorPhoneNumber
                    : "-"}
                </h3>
              </div>
            ) : (
              ""
            )}

            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase titele-name"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Agent Details
              </h5>

              <h6 className="text-uppercase " style={{}}>
                {dashboard.agentName ? dashboard.agentName : "-"}
              </h6>
              <h3
                className="text-uppercase  text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.agentPhoneNumber ? dashboard.agentPhoneNumber : "-"}
              </h3>
            </div>
          </div>
          <div style={{ position: "relative", left: "52%" }}>
            <DateFilter
              ranges={rangeState}
              handleSelect={(item: any) => handleSelect(item)}
              labelPosition="left"
            />
          </div>
          <div
            className="row"
            style={{ marginTop: "30px", marginBottom: "30px" }}
          >
            <div className="col-md-3 col-12">
              <MetricsCard id="first" title="TOTAL TRANSACTIONS" value={"0"} />
            </div>
            <div className="col-md-3 col-12">
              <MetricsCard id="second" title="POS WITHDRAWALS" value={"0"} />
            </div>
            <div className="col-md-3 col-12">
              <MetricsCard id="third" title="TRANSFERS" value={"0"} />
            </div>
            <div className="col-md-3 col-12">
              <MetricsCard id="fourth" title="COMMISSIONS EARNED" value={"0"} />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-md-4 col-12">
              <UtilityFilters type={""} hasGeneralType typeList={types} />
            </div>
            <div className="col-md-3 col-12">
              <UtilityFilters status={""} hasGeneralStatus />
            </div>
            <div className="col-md-5 col-12">
              <UtilityFilters
                onClear={handleClear}
                handleSearch={(e: any) => setSearchState(e.target.value)}
                searchState={searchState}
                hasSearch
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <button
              className="btn btn-light download__button"
              style={{
                color: PrimaryTheme.primary,
              }}
            >
              <div className="row justify-content-center align-items-center m-0">
                <Icon
                  fontSize="small"
                  style={{
                    marginRight: 5,
                  }}
                >
                  download
                </Icon>{" "}
                Export Transactions
              </div>
            </button>
          </div>

          <div className="row">
            <div className="col-md-12 mb-3" style={{ paddingBottom: "150px" }}>
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr>
                          <th scope="col">S/N</th>
                          <th scope="col">Type</th>
                          <th scope="col">Agent</th>
                          <th scope="col">Date</th>
                          <th scope="col">Reference</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Commission</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr
                              key={index}
                              onClick={() =>
                                history.push(`/pos-transactions/${item.id}`)
                              }
                            >
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td style={{ display: "flex" }}>
                                <div className="row m-0 justify-content-start align-items-center">
                                  <Icon
                                    fontSize="small"
                                    style={{
                                      color: PrimaryTheme.lightGreen,
                                      marginRight: 5,
                                    }}
                                  >
                                    fiber_manual_record
                                  </Icon>
                                </div>
                                {item.transactionTypeName}
                              </td>
                              <td>{item.agentName ? item.agentName : "-"}</td>
                              <td>{Functions.getDate(item.transactionDate)}</td>
                              <td>{item.reference ? item.reference : "-"}</td>
                              <td>
                                {item.amount
                                  ? Functions.getCurrency(item.amount)
                                  : Functions.getCurrency("0")}
                              </td>
                              <td>
                                {item.aggregatorCommission
                                  ? Functions.getCurrency(
                                      item.aggregatorCommission
                                    )
                                  : Functions.getCurrency("0")}
                              </td>
                              <td style={{ display: "flex" }}>
                                {item.status === 1 && (
                                  <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                                {item.status === 2 && (
                                  <span className="badge badge-pill badge-danger p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                                {item.status === 3 && (
                                  <span className="badge badge-pill badge-success p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}

                                <IconButton size="small">
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.light,
                                    }}
                                  >
                                    more_vert
                                  </Icon>
                                </IconButton>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {transactions.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={transactions.total && transactions.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>

        <StatusAlert
          subtitle={subtitle}
          title={title}
          buttonTitle="Goto POS"
          backTitle="Back to dashboard"
          goBack={goBack}
          onClick={goto}
        ></StatusAlert>
      </div>
    </React.Fragment>
  );
}
